import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BoardService } from '../shared/services/board/board.service';
import { DashboardsSubMenuUrl } from '../shared/enums/dashboards-submenu.enum';

export const redirectToBoardGuard: CanActivateFn = () => {
	const boardService = inject(BoardService);
	const router = inject(Router);

	const boards = boardService.boards();

	if (boards.length > 0) {
		const firstBoard = boards[0];
		return router.createUrlTree(['/dashboards', firstBoard.type, firstBoard.id]);
	}

	return router.createUrlTree([DashboardsSubMenuUrl.createboard]);
};
